import timelinesReducer from "./reducers";

export default timelinesReducer;